<template>
    <div class="section pt-1">
        <div class="grq-filter-row">
            <select class="grq-filter-select mal-text" v-model="filter_type" @change="getRequests()">
                <option value="">എല്ലാ ലെവലും</option>
                <option value="4">ശാഖാ അപേക്ഷകൾ</option>
                <option value="3">മണ്ഡലം അപേക്ഷകൾ</option>
                <option value="2">ജില്ലാ അപേക്ഷകൾ</option>
                <option value="1">സ്റ്റേറ്റ് അപേക്ഷകൾ</option>
            </select>
            <select class="grq-filter-select mal-text" v-model="filter_wing" @change="getRequests()">
                <option value="">എല്ലാ വിങ്ങും</option>
                <option v-for="w in wingOptions" :key="w.value" :value="w.value">{{ w.label }}</option>
            </select>
        </div>
    </div>

    <div class="section text-center mt-2" v-if="loading">
        <div class="spinner-border text-primary" role="status"></div>
    </div>

    <div class="section mt-2" v-else>
        <div v-if="!responseData.list.length" class="grq-empty mal-text">
            <ion-icon name="document-text-outline"></ion-icon>
            <span>അപേക്ഷകൾ ഒന്നും കണ്ടെത്തിയില്ല</span>
        </div>

        <div v-else class="grq-list">
            <router-link
                v-for="requestData in responseData.list"
                :key="requestData.id"
                :to="requestData.requestDetails.edit ? ('request/' + requestData.id) : ('request-view/' + requestData.id)"
                class="grq-item"
            >
                <div class="grq-item-main">
                    <div class="grq-item-header">
                        <span class="grq-item-id">#{{ requestData.id }}</span>
                        <span class="grq-item-date">{{ getFormattedDate(requestData.created_at) }}</span>
                    </div>
                    <div class="grq-item-title mal-text">
                        {{ requestData.requestDetails.type }} — {{ requestData.requestDetails.from }} നൽകിയ അപേക്ഷ
                    </div>
                    <div class="grq-item-badges">
                        <span class="badge grq-badge-wing">{{ requestData.requestDetails.wing }}</span>
                        <span class="badge" :class="statusBadgeClass(requestData.requestDetails.track_status)">
                            {{ requestData.requestDetails.track_status }}
                        </span>
                    </div>
                    <div class="grq-item-status mal-text" :class="statusTextClass(requestData.requestDetails.track_status)" v-if="requestData.requestDetails.current_status">
                        {{ requestData.requestDetails.current_status }}
                    </div>
                </div>
                <ion-icon name="chevron-forward-outline" class="grq-item-chevron"></ion-icon>
            </router-link>
        </div>
    </div>
</template>

<script>
import UserService from "../../services/user.service";
import moment from 'moment'

export default {
    name: 'RequestList',
    data() {
        return {
            loading: false,
            responseData: {
                list: []
            },
            filter_type: '',
            filter_wing: '',
            wingOptions: [
                { value: '1', label: 'Wisdom' },
                { value: '2', label: 'Youth' },
                { value: '3', label: 'Students' },
                { value: '4', label: 'Womens' },
                { value: '5', label: 'Balavedi' },
                { value: '6', label: 'Girls' },
            ],
        };
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        }
    },
    mounted() {
        if (!this.currentUser) {
            location.replace('/');
            return;
        }
        this.$root.updateParent('Wisdom Guide Requests');
        this.filter_type = this.$route.query.filter_type || '';
        this.filter_wing = this.$route.query.filter_wing || '';
        this.getRequests();
    },
    methods: {
        getFormattedDate(date) {
            return moment(date).format("DD-MM-YYYY");
        },
        statusBadgeClass(status) {
            if (status === 'Request Completed') return 'bg-success';
            if (status === 'Request Received') return 'bg-info text-dark';
            if (status === 'Request Rejected') return 'bg-danger';
            if (status === 'Request Pending') return 'bg-warning text-dark';
            return 'bg-primary';
        },
        statusTextClass(status) {
            if (status === 'Request Completed') return 'text-success';
            if (status === 'Request Received') return 'text-info';
            if (status === 'Request Rejected') return 'text-danger';
            if (status === 'Request Pending') return 'text-warning';
            return 'text-primary';
        },
        getRequests() {
            // replace, not push — this fires on the initial mount too, and pushing would
            // stack a redundant history entry, making the browser back button need two
            // clicks (one to undo this URL sync, one to actually leave the page).
            this.$router.replace({
                path: this.$route.path,
                query: {
                    ...this.$route.query,
                    filter_type: this.filter_type,
                    filter_wing: this.filter_wing,
                }
            }).catch(() => {});
            this.loading = true;
            UserService.authPostRequest('get-requests', {
                user_level_id: parseInt(this.$route.params.id),
                user_level: parseInt(this.$route.params.sub_level),
                filter_wing: this.filter_wing,
                filter_type: this.filter_type,
            }).then(
                (response) => {
                    this.loading = false;
                    if (response.data.status == 'success') {
                        this.responseData = response.data.data;
                    }
                },
                () => {
                    this.loading = false;
                }
            );
        },
    },
};
</script>

<style scoped>
.grq-filter-row {
    display: flex;
    gap: 8px;
}

.grq-filter-select {
    flex: 1;
    min-width: 0;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-color: #fff;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='none' stroke='%2364748b' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round' d='M1 1l5 5 5-5'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 12px center;
    border: 1.5px solid #dbe3ff;
    border-radius: 10px;
    padding: 10px 30px 10px 12px;
    font-size: 13px;
    font-weight: 600;
    color: #27173E;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.grq-filter-select:focus {
    outline: none;
    border-color: #1a418c;
}

.grq-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding: 40px 12px;
    color: #6c757d;
    font-size: 0.92rem;
    background: #fff;
    border-radius: 10px;
    border: 1px dashed #ced4da;
}

.grq-empty ion-icon {
    font-size: 32px;
    color: #ced4da;
}

.grq-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.grq-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 14px 16px;
    text-decoration: none;
    background: #fff;
    border: 1px solid #dee2e6;
    border-radius: 10px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    transition: background-color 0.15s ease;
}

.grq-item:active {
    background: #f8f9fa;
}

.grq-item-main {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
    flex: 1;
}

.grq-item-header {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 0.78rem;
}

.grq-item-id {
    font-weight: 700;
    color: #1a418c;
}

.grq-item-date {
    color: #6c757d;
}

.grq-item-title {
    font-size: 0.92rem;
    font-weight: 600;
    color: #27173E;
    line-height: 1.4;
    word-break: break-word;
}

.grq-item-badges {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 2px;
}

.grq-badge-wing {
    background: #eef2ff;
    color: #1a418c;
}

.grq-item-status {
    font-size: 0.82rem;
    font-weight: 600;
    margin-top: 2px;
}

.grq-item-chevron {
    flex-shrink: 0;
    font-size: 20px;
    color: #adb5bd;
}
</style>
